module.exports = __webpack_public_path__ + "media/images/recruit/section/icon-cross-5b28d23c50f9de4003c18e89a07498f0.svg";